import { Grid, Box } from '@mui/material';
import styled from '@emotion/styled';
import { useAppSelector } from '@/redux/hooks';
import { selectChildrenByTitleIdMap } from '@/redux/selectors/titleV2Selectors';
import { useTitleURLParser } from '@/components/TitleDetail/v2/hooks/useTitleURLParser';
import TitleBrowserListV2 from '@/components/TitleDetail/v2/TitleBrowserV2/TitleBrowserListV2';
import { useMemo } from 'react';
import { TitleEntityV2 } from '@/redux/slices/titleV2Slice.types';

const TitleBrowserV2 = () => {
  const { path } = useTitleURLParser();
  const childrenByTitleId = useAppSelector(selectChildrenByTitleIdMap);

  const nonVersionChildrenCount = useMemo(
    () =>
      path.map((titleId, index) => {
        if (index === 0) {
          // skip the root title, since it has no parent (or rather we don't care about children count of the root title)
          return undefined;
        }

        const parentChildren: TitleEntityV2[] | undefined = childrenByTitleId[path[index - 1]];
        if (parentChildren) {
          const selectedTitle = parentChildren.find((c) => c.id === titleId);
          if (!selectedTitle) {
            return undefined;
          }

          return selectedTitle.relationships.children.filter((c) => c.entity_type !== 'version').length;
        }

        return undefined;
      }),
    [path, childrenByTitleId]
  );

  return (
    <BoxContainer>
      <Grid container columnSpacing={4} flexWrap="nowrap">
        {path.map((titleId, index) => (
          <TitleBrowserListV2 key={titleId} titleId={titleId} nestLevel={index + 1} itemsCountBasedOnParent={nonVersionChildrenCount[index]} />
        ))}
      </Grid>
    </BoxContainer>
  );
};

export default TitleBrowserV2;

const BoxContainer = styled(Box)`
  position: relative;
  overflow-y: auto;
`;
